import { useEffect, useState } from 'react';

// Reports navigator.onLine + listens for online/offline events. Also exposes
// a flushOutbox() that nudges the service worker to retry queued POSTs.
export function useOnlineStatus() {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);
  useEffect(() => {
    const on = () => { setOnline(true); flushOutbox(); };
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}

export async function flushOutbox() {
  try {
    const reg = await navigator.serviceWorker?.ready;
    reg?.active?.postMessage({ type: 'flush-outbox' });
  } catch { /* no-op */ }
}
